export enum MembershipPlanPeriods {
  Annual = 'Annual',
  Days_14 = '14 Day',
  Days_30 = '30 Day',
}
